import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RoleService {

  getRole(): string {
    return localStorage.getItem('role') || '';
  }

  /**
   * Check if current user has any of the given roles
   * Usage in component: roleService.hasRole(['admin', 'Station Incharge'])
   * Usage in template: *ngIf="roleService.hasRole(['admin'])"
   */
  hasRole(roles: string[]): boolean {
    return roles.includes(this.getRole());
  }

  isAdmin(): boolean {
    return this.getRole() === 'admin';
  }

  isStationIncharge(): boolean {
    return this.getRole() === 'fire_station_incharge' || this.getRole() === 'fire_station';
  }

  isOfficial(): boolean {
    return ['adc_imc','dyc_imc','fire_chief_superintendent','adhoc_officers_fire_department_x2','commissioner_imc'].includes(this.getRole());
  }
}
